<template>
  <TitleWrapper
    :filter-option="true"
    :title="`${pluralToSingular(sectionName)}_FEE`"
    :tooltip-title="`${pluralToSingular(sectionName)}_FEE_TOOLTIP`"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiInput
          v-model.trim="filtersPayload.title"
          title="TITLE"
          type="text"
          placeholder="TITLE"
          :filter="FILTERS_LIST.TITLE"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.fee_type_id"
          title="FEE_TYPE"
          :options="feeTypes"
          input-color="bg-white"
          reduce="id"
          :label="'title'"
          :filter="{
            option: FILTER_KEYS.EQUAL,
            key: 'fee_type_id',
          }"
          :search-through-api="true"
          @emitQuery="updateQuery"
          @search="fetchFeeTypes"
        />
        <UiDatePicker
          v-model="filtersPayload.due_date_after"
          title="Due Date After"
          :date-mode="DATE_MODE.START_DATE_TIME"
          :filter="FILTERS_LIST.DUE_DATE_GREATER_THAN_EQUAL"
          @emitQuery="updateQuery"
          @change="dueDateAfter"
        />
        <UiDatePicker
          v-model="filtersPayload.due_date_before"
          title="Due Date Before"
          :date-mode="DATE_MODE.END_DATE_TIME"
          :filter="FILTERS_LIST.DUE_DATE_LESS_THAN_EQUAL"
          @emitQuery="updateQuery"
          @change="dueDateBefore"
        />
        <UiInput
          v-model:initial="filtersPayload.fee_amount_greater_than"
          v-model:secondary="filtersPayload.fee_amount_less_than"
          title="Fee Amount"
          type="range"
          placeholder="Fee Amount"
          rules="numeric"
          :filter="FILTERS_LIST.FEE_AMOUNT_RANGE"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiInput from '@components/UiElements/UiInputBox.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import UiDatePicker from '@components/UiElements/UiDatePicker.vue'
import { getCountFromObject, pluralToSingular } from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { mapActions, mapState, mapGetters } from 'vuex'
import filterMixins from '@/src/mixins/filter-mixins.js'
import { DATE_MODE } from '@/src/constants/date-time-constants.js'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
import { buildWhereQuery } from '@/src/utils/filters'

export default {
  components: {
    UiInput,
    UiSingleSelect,
    TitleWrapper,
    UiDatePicker,
    InputFieldWrapper,
  },
  mixins: [filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      DATE_MODE,
      FILTER_KEYS,
      $where: {},
      FILTERS_LIST,
      filtersPayload: {
        title: '',
        fee_type_id: '',
        fee_amount_greater_than: '',
        fee_amount_less_than: '',
        due_date_after: '',
        due_date_before: '',
        displayedColumns: [],
      },
      feeTypes: [],
      filtersCount: 0,
    }
  },

  computed: {
    ...mapState({
      currentSectionScope: (state) => state.layout.currentSectionScope.id,
      currentCampusScope: (state) => state.layout.currentCampusScope.id,
      ...mapGetters('featureNaming', ['sectionName']),
    }),
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.clearFilters()
      },
    },

    currentSectionScope: {
      handler() {
        this.clearFilters()
      },
    },
  },
  mounted() {
    this.updateDisplayedColumnList()
    this.fetchFeeTypes()
  },
  methods: {
    pluralToSingular,
    fetchFeeTypes(query = '') {
      let queryPayload = { $where: { ...buildWhereQuery(FILTER_KEYS.ILIKE, 'title', query) } }
      this.getFeeTypes(queryPayload).then((res) => {
        this.feeTypes = res?.data.records
      })
    },
    getFiltersCount() {
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
    ...mapActions('fee', ['getFeeTypes']),
  },
}
</script>
